import React from 'react'
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent";
const EntreCXC =({match})=>(
    <Switch>
          <Route  path={`${match.url}/ProviderRegister`} component={asyncComponent(()=>import( './ProviderRegister/index'))} />
          <Route  path={`${match.url}/BuyGoodsAndServices`} component={asyncComponent(()=>import( './BuyGoodsAndServices/index'))} />
          <Route  path={`${match.url}/CreditNote`} component={asyncComponent(()=>import( './CreditNote/index'))} />
          <Route  path={`${match.url}/DebitNote`} component={asyncComponent(()=>import( './DebitNote/index'))} />
          <Route  path={`${match.url}/ProviderPayment`} component={asyncComponent(()=>import( './ProviderPayment/index'))} />
          <Route  path={`${match.url}/ReplenishmentExpenses`} component={asyncComponent(()=>import( './ReplenishmentExpenses/index'))} />
          <Route  path={`${match.url}/CommercialApproval`} component={asyncComponent(()=>import( './CommercialApproval/index'))} />
          <Route  path={`${match.url}/DebitNotice`} component={asyncComponent(()=>import( './DebitNotice/index'))} />
          <Route  path={`${match.url}/CreditNotice`} component={asyncComponent(()=>import( './CreditNotice/index'))} />
        
    </Switch>
)
export default EntreCXC;